module.exports = __webpack_public_path__ + "static/media/1015188.d4533c5a.jpg";